module.exports = __webpack_public_path__ + "img/chang-tien-wei-8.239217ea.jpg";